import React, { Fragment, useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Col, Card, Container } from "reactstrap";
import { TopCenter, directiontoaster } from "../../Constant";
import { toast } from "react-toastify";
import ModalLink from "../Modal/Modal";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { FaRegFilePdf, FaRegSave, FaRegEdit } from "react-icons/fa";
import { Breadcrumbs, Btn } from "../../AbstractElements";
import ModalDeleteBadge from "../ModalDeleteBadge/ModalBadge";
import ModelNewsFeed from "../ModalDeleteNewsFeed/ModalNewsFeed";
import "./styles.css";
import ModalDeleteNewsFeed from "../ModalDeleteNewsFeed/ModalNewsFeed";
import ModelDeleteNewsProvider from "../ModelDeleteNewsProvider/ModelDeleteNewsProvider";
import ModalDelete from "../ModalDelete/Modal";

const ViewNewsFeed = () => {
	const API_BASE_URL = window.appConfig.API_BASE_URL;
	const [data, setData] = useState([]);
	const [error, setError] = useState({ error: false, message: "" });
	const [pageLoaded, setPageLoaded] = useState(false);

	const fetchFeeds = () => {
		const source = axios.CancelToken.source();
		const authToken = sessionStorage.getItem("token");

		const feeds = axios
			.get(`${API_BASE_URL}/NewsFeed`, {
				headers: {
					Authorization: `Bearer ${authToken}`,
				},
				cancelToken: source.token,
			})
			.then((res) => {
				setData(res.data);
				setPageLoaded(true);
			})
			.catch((err) => {
				console.error(err);
			});
	};

	useEffect(() => {
		fetchFeeds();
	}, []);

	const directiontoaster = (toastname) => {
		switch (toastname) {
			case "directionssuccessToast":
				toast.success("The feed was successfully deleted", {
					position: toast.POSITION.TOP_CENTER,
					autoClose: 1500,
				});
				break;
			case "directionsdangerToast":
				toast.error("There was an error deleting the feed", {
					position: toast.POSITION.TOP_CENTER,
					autoClose: 1500,
				});
				break;
		}
	};

	const deleteHandler = async (newsFeedId) => {
		try {
			const response = await axios.delete(
				`${API_BASE_URL}/NewsFeed/NewsFeed/${newsFeedId}`
			);
			fetchFeeds();
			directiontoaster("directionssuccessToast");
		} catch (error) {
			console.error("Something went wrong", error);
			directiontoaster("directionsdangerToast");
		}
	};

	const providerNameTemplate = (rowData) => {
		return rowData.newsProvider ? rowData.newsProvider.name : "";
	};

	const categoryNameTemplate = (rowData) => {
		return rowData.category ? rowData.category.categoryName : "";
	};

	function actionColumnBodyTemplate(newsFeeds) {
		return (
			<>
				<Link to={`/EditNewsFeeds/:${newsFeeds.newsFeedId}`}>
					<i className="candidate-icons" title="Edit News Feeds">
						<FaRegEdit />
					</i>
				</Link>
				<ModalDelete
					onDelete={() => deleteHandler(newsFeeds.newsFeedId)}
					deleteMessage={`Are you sure you would like to delete?`}
				/>
			</>
		);
	}

	return (
		<Fragment>
			<Breadcrumbs
				parent="News Feeds"
				title="Feeds"
				mainTitle="News Feed Management"
			/>
			<Container fluid={true}>
				<Col>
					<Card>
						<DataTable
							scrollable
							rowHover
							rowClassName={"mustHaveRow"}
							value={data}
							size={"small"}
							paginator
							rows={25}
							rowsPerPageOptions={[10, 25, 50, 100]}
							filterDisplay={"row"}
							id="badge-table"
						>
							<Column
								filterHeaderClassName="p-inputtext-sm"
								showFilterMenu={false}
								filter={true}
								header="Provider"
								body={providerNameTemplate}
							></Column>
							<Column
								filterHeaderClassName="p-inputtext-sm"
								showFilterMenu={false}
								filter={true}
								header="URL"
								field="rssUrl"
							></Column>
							<Column
								filterHeaderClassName="p-inputtext-sm"
								showFilterMenu={false}
								filter={true}
								header="Category"
								body={categoryNameTemplate}
							></Column>
							<Column
								className="candidate-icon-list"
								body={actionColumnBodyTemplate}
								header=""
							></Column>
						</DataTable>
						<Link to={`${process.env.PUBLIC_URL}/AddNewsFeeds`}>
							<Btn attrBtn={{ color: "primary", id: "feed-badge" }}>
								Add News Feed
							</Btn>
						</Link>
					</Card>
				</Col>
			</Container>
		</Fragment>
	);
};

export default ViewNewsFeed;
